export const PathRoot = {
    root: '/',
    auth: 'auth/*',
    notfound: '*',
}

export const AuthRoot = {
    reset: 'reset'
}